import { z } from 'zod';
export * from './errors.js';
export * from './enums.js';
export * from './auth.js';
export * from './admin.js';
export * from './admin-session.js';
export * from './audit-log.js';
export * from './app-settings.js';
export * from './api-token.js';
export * from './session-link.js';
export * from './share.js';
export * from './asset-query.js';
export * from './asset-detail.js';
export * from './filter-expr.js';
export * from './saved-filter.js';
export * from './comments.js';
export * from './bulk-actions.js';
export * from './download-selection.js';
export * from './file-errors.js';
export * from './exif.js';
export * from './taxonomy.js';
export * from './tagging.js';
export * from './ai-trace.js';
export * from './organize.js';
export * from './empty-folders.js';
export * from './folder-tree.js';
export * from './folder-ops.js';
export * from './compress.js';
export * from './rotate.js';
export * from './trash.js';
export * from './missing-assets.js';
export * from './dedup.js';
export * from './exact-dedup.js';
export * from './ai.js';
export * from './job.js';
export * from './job-event.js';
export * from './scan.js';
/**
 * Contrat de `GET /api/health` — consommé par la SPA (bandeau version, à-propos).
 * Les schémas Zod vivent ici : source unique de vérité front + back.
 */
export const healthSchema = z.object({
    status: z.literal('ok'),
    name: z.string(),
    version: z.string(),
    buildId: z.string(),
    publicHostname: z.string(),
    /**
     * Passerelle d'authentification (ADR-0008) : URL vers laquelle un visiteur SANS
     * session est renvoyé pour se faire identifier par l'app tierce (pnyx), qui le
     * renvoie ici avec un `?access=<jeton>`. `null` = aucune passerelle → l'écran de
     * connexion habituel. Exposé par `/api/health` (PUBLIC — c'est justement le
     * visiteur non authentifié qui en a besoin) et non au build : l'URL est une
     * config de déploiement, elle ne doit pas exiger un rebuild de la SPA.
     *
     * `.default(null)` (et non `.optional()`) : le serveur envoie TOUJOURS la clé
     * (le type de sortie l'exige), mais un client tolère son absence. Sans danger
     * ici — le piège Zod v4 `toJSONSchema` ne vise que les schémas de corps/query
     * de route, or `/api/health` n'en déclare aucun.
     */
    accessGatewayUrl: z.string().nullable().default(null),
});
//# sourceMappingURL=index.js.map